import WithLoader from "~/ui-rtk/components/layout/WithLoader/WithLoader"
import HomeDashboardV2 from "~/ui-rtk/components/features/dashboards/HomeDashboardV2"

export default function HomePageV2() {
  return (
    <div className="min-h-full px-6 py-6 bg-basic-black text-basic-light">
      <WithLoader isLoading={false}>
        <HomeDashboardV2 />
      </WithLoader>
    </div>
  )
}
